<template>
    <section
        v-if="content"
        class="c-video-audio-cta"
    >
        <div class="c-video-audio-cta__title">
            <p v-html="content.custom.field4" />
        </div>
        <div class="c-video-audio-cta__action">
            <y-button
                color="primary"
                :tag="isLink(content.custom['field6']) ? 'a' : 'router-link'"
                :to="content.custom['field6']"
                :href="content.custom['field6']"
            >
                {{ content.custom['field5'] }}
            </y-button>

            <y-button
                :tag="isLink(content.custom['field8']) ? 'a' : 'router-link'"
                :to="content.custom['field8']"
                :href="content.custom['field8']"
                class="demo-btn"
            >
                {{ content.custom['field7'] }}
            </y-button>
        </div>
    </section>
</template>

<script>
    import { isLink } from '@/helpers/helpers';

    export default {
        name : 'CallToAction',
        props: {
            content: Object,
        },
        methods: {
            isLink,
        },
    };
</script>

<style lang="scss" src="./index.scss"></style>
